import { FC } from 'react';
import { AxiosError } from 'axios';

import { InternalServerError } from './InternalServerError';
import { ForbiddenError } from './ForbiddenError';
import { GeneralError } from './GeneralError';

export interface ErrorProps {
    error: AxiosError;
}

export const Error: FC<ErrorProps> = ({ error }) => {
    switch (error.response?.status) {
        case 403:
            return <ForbiddenError />;
        case 500:
            return <InternalServerError />;
        default:
            return <GeneralError error={error} />;
    }
};
